import { getErrorCodes } from '@/utils'

const EMAIL_ALREADY_TAKEN = 'already_taken'

/**
 * Check if email is already taken
 */
const isEmailTaken = (errorData: any) => {
  // The API returns a 'already_taken' error if the email already exists in out DB
  const errorDetails = errorData?.cause?.error_details
  const errorCodes = getErrorCodes(errorDetails, ['email'])

  return errorCodes.includes(EMAIL_ALREADY_TAKEN)
}

export default isEmailTaken
